import * as React from 'react';
import AngleRight from '../components/AngleRight';
import { Link } from 'gatsby';
import styled from 'styled-components';

// const Link = styled.a`
// 	display: inline-block;
// `;

const ViewOpenRoles = () => (
	<Link to='/careers/#open-roles' className='primary-button animate-right cta viewOpenRoles'>
		View Open Roles<AngleRight />
	</Link>
);

export default ViewOpenRoles;
